import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["title", "slug"];

  connect() {
    // Only auto-generate slug if the slug field is empty
    this.autoGenerate =
      !this.slugTarget.value || this.slugTarget.value.trim() === "";
  }

  updateSlug() {
    // Only auto-generate if slug is empty or user hasn't manually edited it
    if (!this.autoGenerate) return;

    const title = this.titleTarget.value;
    const slug = this.generateSlug(title);
    this.slugTarget.value = slug;
  }

  // User edited the slug manually, stop auto-generation and format input
  manualEdit() {
    this.autoGenerate = false;
    this.formatSlugInput();
  }

  // Format the slug field input as URL-friendly (lighter version for real-time)
  formatSlugInput() {
    const currentValue = this.slugTarget.value;
    const formattedValue = this.generateSlug(currentValue);

    // Only update if the value actually changed to avoid cursor jumping
    if (currentValue !== formattedValue) {
      const cursorPosition = this.slugTarget.selectionStart;
      this.slugTarget.value = formattedValue;

      // Try to maintain cursor position (adjust if formatted value is shorter)
      const newPosition = Math.min(cursorPosition, formattedValue.length);
      this.slugTarget.setSelectionRange(newPosition, newPosition);
    }
  }

  // Apply final formatting when user leaves the slug field
  finalizeSlug() {
    const currentValue = this.slugTarget.value;
    const finalValue = this.generateSlug(currentValue).replace(/^-+|-+$/g, ""); // trim hyphens from beginning and end of slug.

    if (currentValue !== finalValue) {
      this.slugTarget.value = finalValue;
    }

    this.enableAutoGenerate();
  }

  // User cleared the slug, resume auto-generation
  enableAutoGenerate() {
    if (!this.slugTarget.value || this.slugTarget.value.trim() === "") {
      this.autoGenerate = true;
      this.updateSlug();
    }
  }

  generateSlug(text) {
    return text
      .toLowerCase()
      .replace(/[àáâãäå]/g, "a")
      .replace(/[èéêë]/g, "e")
      .replace(/[ìíîï]/g, "i")
      .replace(/[òóôõö]/g, "o")
      .replace(/[ùúûü]/g, "u")
      .replace(/[ýÿ]/g, "y")
      .replace(/[ñ]/g, "n")
      .replace(/[ç]/g, "c")
      .replace(/[æ]/g, "ae")
      .replace(/[œ]/g, "oe")
      .replace(/[^a-z0-9\s-]/g, "") // Remove special characters
      .replace(/[\s_]+/g, "-") // Replace spaces and underscores with hyphens
      .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
      .replace(/^-+/g, ""); // Only trim hyphens from start (not end) for better real-time UX
  }
}
